import clsx from 'clsx';
import type { ReactNode } from 'react';

import { Icon } from '@flintmint/web-shared/components/icon';

import styles from './context-item.module.scss';

export const DefaultFilePreview = (props: DefaultFilePreviewProps) => {
  const { meta, actions, hasActions, uploadStatus, audioTimeLabel, sourceTypeLabel, showAudioPreview } = props;

  const hasHeaderActions = !!audioTimeLabel || hasActions;

  return (
    <ul>
      <li
        className={clsx(styles.contextType, sourceTypeLabel && styles[sourceTypeLabel], {
          [styles.audio]: showAudioPreview,
        })}
      >
        <Icon type={showAudioPreview ? 'voice' : 'file-1'} multiColor={showAudioPreview} size={30} />
        {!showAudioPreview && <span data-testid="source-type-label">{sourceTypeLabel}</span>}
      </li>

      <li className={styles.content}>
        {meta}
        {(!uploadStatus || uploadStatus === 'error') && hasHeaderActions && (
          <div className={styles.headerActions}>
            {!!audioTimeLabel && <span className={styles.audioTimeBadge}>{audioTimeLabel}</span>}
            {actions}
          </div>
        )}
      </li>
    </ul>
  );
};

interface DefaultFilePreviewProps {
  meta: ReactNode;
  actions: ReactNode;
  hasActions?: boolean;
  showAudioPreview: boolean;
  audioTimeLabel?: string | null;
  sourceTypeLabel?: string | null;
  uploadStatus?: 'uploading' | 'error';
}
